import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import { Nullable } from '@/shared/types/app.types'
import { ConfigurationPreformattedResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import PreformattedEditor from '@/modules/configurationModule/detail/local-samples/preformatted/shared/components/preformatted-editor/preformatted-editor.vue'
import { preformattedDiagnosisServices } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted-diagnosis.service'

@Component({
    components: {
        PreformattedEditor
    }
})
export default class LocalPreformattedModalDiagnosis extends Vue {
    @Prop() readonly selectedRow!: Nullable<ConfigurationPreformattedResponse>
    @Prop() readonly broadcastChannelPostMessageFunction!: Function

    get preformattedId(): number {
        return this.selectedRow?.id!
    }

    get laboratoryId(): number {
        return this.selectedRow?.laboratory?.labId!
    }

    get actionTitle(): string {
        return this.$t('configuration.modal.preformated.diagnosis').toString()
    }

    get service(): typeof preformattedDiagnosisServices {
        return preformattedDiagnosisServices
    }
}
